import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './safetyAuthorize.json';

const validateSafetyAuthorize = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['safetyAuthorizeController/validateSafetyAuthorize'].success.default)));
};

const checkOTP = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['safetyAuthorizeController/checkOTP'].success.default)));
};

const checkSafetyAuthorize = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['safetyAuthorizeController/checkSafetyAuthorize'].success.default)));
};

const validateAndSendOTP = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['safetyAuthorizeController/validateAndSendOTP'].success.default)));
};

export const handlers = [
  rest.post(
    getApiEndpoint('safetyAuthorizeController/validateSafetyAuthorize'),
    withScenario(withAuthCheck(validateSafetyAuthorize))
  ),
  rest.post(getApiEndpoint('safetyAuthorizeController/checkOTP'), withScenario(checkOTP)),
  rest.post(getApiEndpoint('safetyAuthorizeController/checkSafetyAuthorize'), withScenario(checkSafetyAuthorize)),
  rest.post(getApiEndpoint('safetyAuthorizeController/validateAndSendOTP'), withScenario(validateAndSendOTP)),
];
